module.exports = __webpack_public_path__ + "img/sun.73e38632.svg";